export default "__VITE_ASSET__D2KF4L2p__"